import { isDevice } from 'expo-device';
import type { DevicePushToken } from 'expo-notifications';
import {
  AndroidImportance,
  getDevicePushTokenAsync,
  getPermissionsAsync,
  PermissionStatus,
  requestPermissionsAsync,
  setNotificationChannelAsync
} from 'expo-notifications';

import {
  ANDROID_NOTIFICATION_CHANNEL_ID,
  ANDROID_NOTIFICATION_CHANNEL_NAME
} from '@/features/notifications/constants/notifications';
import { useNotificationStore } from '@/features/notifications/store/useNotificationStore';
import { isAndroid, isIOS, isWeb } from '@/shared/utils/platform';

export const registerForPushNotificationsAsync = async () => {
  // Web push is not supported yet — skip registration so the browser is not
  // asked for notification permission and no "undetermined" errors appear.
  if (isWeb) {
    return;
  }

  let token: string | undefined;

  if (isAndroid) {
    await setNotificationChannelAsync(ANDROID_NOTIFICATION_CHANNEL_ID, {
      name: ANDROID_NOTIFICATION_CHANNEL_NAME,
      importance: AndroidImportance.DEFAULT
    });
  }

  if (isDevice || isIOS) {
    // in theory the iOS simulator shouldn't support push, but it does, hence the exception isIOS
    const { status: existingStatus } = await getPermissionsAsync();
    let finalStatus = existingStatus;
    if (existingStatus !== PermissionStatus.GRANTED) {
      const { status } = await requestPermissionsAsync();
      finalStatus = status;
    }
    if (finalStatus !== PermissionStatus.GRANTED) {
      console.error(
        'Failed to get push token for push notification:',
        finalStatus
      );
      return;
    }
    try {
      const deviceToken: DevicePushToken = await getDevicePushTokenAsync();
      token = deviceToken.data as string;
    } catch (error) {
      console.error(error);
    }
  }
  useNotificationStore.getState().updateToken(token);

  return token;
};
